import React, { FC } from "react";
import { IFormItem } from "../Types";
import { Form, DatePicker, Input } from "antd";
export const __FormDatePicker: FC<IFormItem> = (props) => {
    return (
        <Form.Item
            label={props.fieldLabel}
            name={props.fieldName}
            rules={props.rules}
            labelCol={props.labelCol}
        >
            <DatePicker
                format="YYYY-MM-DD HH:mm:ss"
                showTime={props.showTime}
                disabledTime={props.disabledDateTime}
                disabled={props.disable}
                allowClear
                showNow={true}
            />
        </Form.Item>
    )
}